import * as React from "react";
import antd, { Row, Col } from 'antd';
import RegistrationWizardForm from "../../components/Registration/RegistrationWizard/RegistrationWizardForm";
import CenteredPageContainer from "components/Layout/CenteredPageContainer";


export interface Props {
    children?: React.ReactNode
}

export interface State {
}

export default class RegistrationWizardPage extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props)

        this.state = {
        }
    }

    render() {
        return (
            <CenteredPageContainer title="Registration">
                <RegistrationWizardForm />
            </CenteredPageContainer>
        )
    }
}
